import { useContext } from 'react';
import Image from 'next/image';
import {
    NewPlanStages,
    policyDetailsInitState,
} from 'components/newPlan/constants';
import { getImageBasePath } from 'utils/generics';
import { MPosContext } from 'utils/context';
import {
    SegmentEventActionTypes,
    SegmentEventNameTypes,
    SegmentEventActionNames,
    SegmentEventButtonNames,
} from 'utils/segment/constants';
import * as Styles from './styles';
import sendSegmentEvent from 'utils/segment';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';

function PlansHeader() {
    const { planDetails, setActiveStage, setPlanDetails, userDetails } =
        useContext(MPosContext);
    const { isMobile } = useResponsiveDevice();

    const { device } = planDetails;

    const onEdit = () => {
        setActiveStage(NewPlanStages.MODEL);
        setPlanDetails({ ...policyDetailsInitState });
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.CLICK_EDIT_MODEL,
                button_name: SegmentEventButtonNames.CLICK_EDIT_MODEL,
            },
            { userDetails, isMobile }
        );
    };

    return (
        <>
            <Styles.HeaderWrapper>
                <Styles.PhoneIconFlex>
                    <Image
                        width={'11px'}
                        height={'16px'}
                        alt={''}
                        src={getImageBasePath('/icons/phone.svg')}
                    />
                </Styles.PhoneIconFlex>
                <Styles.ModelNameFlex>
                    <Styles.ModelName>{device.name}</Styles.ModelName>
                </Styles.ModelNameFlex>
                <Styles.EditFlex>
                    <Styles.Edit onClick={onEdit}>Edit</Styles.Edit>
                </Styles.EditFlex>
            </Styles.HeaderWrapper>
            <Styles.Hr />
        </>
    );
}

export default PlansHeader;
